<script setup>import { computed as _computed } from 'vue';

  import DropdownWidget from "./dropdown-widget.vue";
  import {
    copyPurchaseOrderPath,
    activatePurchaseOrderPath,
    receivePurchaseOrderPath,
    markAsDraftPurchaseOrderPath,
    cancelPurchaseOrderPath,
  } from "~/routes";

  const props = defineProps({
    order: { type: Object, required: true },
    confirms: { type: Object, required: true },
  });

  const markAsDraftConfirm = _computed(() =>
    props.order.state === "cancelled" ? props.confirms.mark_as_draft_cancelled : null
  );
</script>

<template>
  <DropdownWidget>
    <template #trigger>
      <button class="button is-outlined is-info is-small">
        <span>Actions</span>
        <span class="icon is-small">
          <i class="fas fa-angle-down"></i>
        </span>
      </button>
    </template>

    <template #content>
      <a class="dropdown-item" data-method="post" :href="copyPurchaseOrderPath(order.id)">
        <span class="icon-text">
          <span class="icon"><i class="fa fa-copy"></i></span>
          <span>Duplicate</span>
        </span>
      </a>
      <a
        v-if="order.actions?.includes('activate')"
        class="dropdown-item"
        data-method="post"
        :href="activatePurchaseOrderPath(order.id)"
      >
        <span class="icon-text">
          <span class="icon"><i class="fa fa-check"></i></span>
          <span>Set Active</span>
        </span>
      </a>
      <a
        v-if="order.actions?.includes('receive')"
        class="dropdown-item"
        :href="receivePurchaseOrderPath(order.id)"
      >
        <span class="icon-text">
          <span class="icon"><i class="fa fa-inbox"></i></span>
          <span>Receive</span>
        </span>
      </a>
      <a
        v-if="order.actions?.includes('mark_as_draft')"
        class="dropdown-item"
        data-method="post"
        :data-confirm="markAsDraftConfirm"
        :href="markAsDraftPurchaseOrderPath(order.id)"
      >
        <span class="icon-text">
          <span class="icon"><i class="fa fa-rotate-left"></i></span>
          <span>Mark as Draft</span>
        </span>
      </a>
      <a
        v-if="order.actions?.includes('cancel')"
        class="dropdown-item"
        data-method="post"
        :data-confirm="confirms.cancel"
        :href="cancelPurchaseOrderPath(order.id)"
      >
        <span class="icon-text">
          <span class="icon"><i class="fa fa-xmark"></i></span>
          <span>Cancel</span>
        </span>
      </a>
    </template>
  </DropdownWidget>
</template>
